import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ToolPicker from './ToolPicker';

const { FiPlus } = FiIcons;

const ToolbarMenu = ({ noteId, isReadOnly, onToolAdded, onOpenToolPicker }) => {
  const [showToolPicker, setShowToolPicker] = useState(false);

  if (isReadOnly) return null;

  const handleOpenToolPicker = () => {
    if (onOpenToolPicker) {
      onOpenToolPicker();
    } else {
      setShowToolPicker(true);
    }
  };

  const handleToolPickerClose = (lessonToolId, toolId) => {
    setShowToolPicker(false);
    // If a tool was added (IDs provided), notify the parent component
    if (lessonToolId && toolId && onToolAdded) {
      console.log('Tool added via toolbar, notifying parent:', lessonToolId, toolId);
      onToolAdded(lessonToolId, toolId);
    }
  };

  return (
    <>
      <div className="fixed bottom-4 right-4 z-40">
        <button
          onClick={handleOpenToolPicker}
          className="p-4 rounded-full shadow-lg flex items-center justify-center transition-colors bg-blue-600 text-white hover:bg-blue-700"
        >
          <SafeIcon icon={FiPlus} className="text-xl" />
        </button>
      </div>
      <AnimatePresence>
        {showToolPicker && (
          <ToolPicker noteId={noteId} onClose={handleToolPickerClose} />
        )}
      </AnimatePresence>
    </>
  );
};

export default ToolbarMenu;